import { render, staticRenderFns } from "./StartMission.vue?vue&type=template&id=8f041516"
import script from "./StartMission.vue?vue&type=script&lang=ts"
export * from "./StartMission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports